import { WidgetBaseOption, WidgetQuery } from '../..';


export enum WidgetCardType {
    Counter = 'counter',
    RichText = 'html',

    // Sum = 'sum',
    // Average = 'average',
}

export function isWidgetCardType(value: string): value is WidgetCardType {
    return [WidgetCardType.Counter, WidgetCardType.RichText].some(v => v === value);
}

export interface WidgetCardOption extends WidgetBaseOption {
    type: WidgetCardType,
    query?: WidgetQuery,
    visualization?: WidgetCardHtmlVisualization | WidgetCardCounterVisualization | any;
}


export interface WidgetCardCounterVisualization {
    backgroundColor: string;
    foregroundColor: string;
}

export interface WidgetCardHtmlVisualization {
    value: string;
}

// DATA 

export type WidgetCardDataFormat = 'text' | 'number' | 'currency' | 'percent';

export interface WidgetCardData {
    value: any;
    format: WidgetCardDataFormat;
}